import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AbstractIdbaRequestModel } from 'src/app/shared/models/abstract-idba-request-model';
import { AbstractIdbaService } from 'src/app/shared/utils/abstract-idba-service.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BancoService extends AbstractIdbaService {

  iconesArray: any[] = [];

  constructor(http: HttpClient) { 
    super(http);
    this.programName = "fin/banco/banco.p";
  }

  eliminaImg(parameters) {
    let request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = "pi-elimina-img";
    request.parameters = parameters;
    return this.httpClient.post<any>(environment.apiURLIntegrate, request, { observe: "response" });
  }

  async pesquisaIcones() {
    const request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.programName;
    request.procedure = 'pi-retorna-logos';
    request.parameters = {assunto: "Logo"};

    const response$ = this.httpClient.post<any>(
      environment.apiURLIntegrate,
      request,
      { observe: 'response' }
    );
    const response = await lastValueFrom(response$);
    this.iconesArray = response.body.retorno.logos ?? [];
  }

}
